

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from "@mui/x-date-pickers";

import { Button, Checkbox, Grid, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField } from "@mui/material";
import React, { useEffect } from "react"
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ACTION_TYPES, useEnvioRemessaDispatch, useEnvioRemessaState } from "./context/envio-remessa-context";
import dayjs, { Dayjs } from 'dayjs';
import { IPublishingVehicleResponse } from '../../../model/publication-shipment/response/publising-vehicle-response';
import DefaultUploadFiles from '../../components/default-upload-files';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import SendIcon from '@mui/icons-material/Send';
import { useEnvioRemessaController } from './context/envio-remessa-controller';
import PlainTextArea from '../../components/plain-text-area';

export const EnvioRemessa = () => {
    const { addPublicationShipmentRequest,files, listPublishingVehicleResponse: listVeiculoPublicacaoResponse, fieldIsValid, loading } = useEnvioRemessaState();
    const envioRemessaDispatch = useEnvioRemessaDispatch();
    const { sendPublicationShipment, setFiles,getInit, handleOnChange} = useEnvioRemessaController();


    useEffect(() => {
        (async () => {
            await getInit();
        })();
    },[]);

    return (
        <React.Fragment>
            <LocalizationProvider dateAdapter={AdapterDayjs}>

                <Grid
                    item
                    lg={10}
                    sm={10}
                    xl={10}
                >
                    <InputLabel>Título</InputLabel>
                    <OutlinedInput
                        fullWidth
                        autoComplete='off'
                        onChange={handleOnChange}
                        onBlur={handleOnChange}
                        inputProps={{ maxLength: 500 }}
                        size="small" 
                        name="input-title"
                        defaultValue={addPublicationShipmentRequest?.title}
                        value={addPublicationShipmentRequest?.title}
                        error={addPublicationShipmentRequest?.title === undefined || addPublicationShipmentRequest?.title.length === 0 ? true : false}
                    />
                </Grid>
                <Grid
                    item
                    lg={2}
                    sm={2}
                    xl={2}
                >
                    <InputLabel>Data da Publicação</InputLabel>
                    <DesktopDatePicker format='DD/MM/YYYY' minDate={dayjs()}
                        name="input-publicin"
                        slotProps={{ textField: { fullWidth: true,  size:"small"  } }}
                        value={dayjs(addPublicationShipmentRequest?.publishIn)}
                        onChange={(value: Dayjs | null) => {
                            let publishIn = value?.format("YYYY-MM-DD");
                            envioRemessaDispatch({
                                type: ACTION_TYPES.setAddPublicationShipmentRequest,
                                payload: { ...addPublicationShipmentRequest, publishIn },
                            });
                        }}

                    />

                </Grid>
                <Grid
                    item
                    lg={5}
                    sm={5}
                    xl={5}
                >
                    <InputLabel>Tipo</InputLabel>
                    <Select
                        fullWidth={true}
                        onChange={handleOnChange}
                        size="small" 
                        onBlur={handleOnChange}
                        name="select-type"
                        value={addPublicationShipmentRequest?.type}
                        error={addPublicationShipmentRequest?.type === undefined || addPublicationShipmentRequest?.type === 0 ? true : false}
                    >

                        <MenuItem
                            key={1}
                            value={1}
                        >
                            ROTINA
                        </MenuItem>
                        <MenuItem
                            key={2}
                            value={2}
                        >
                            URGÊNCIA
                        </MenuItem>

                    </Select>

                </Grid>
                <Grid
                    item
                    lg={7}
                    sm={7}
                    xl={7}
                >
                    <InputLabel>Veículo de Publicação</InputLabel>
                    <Select
                        fullWidth
                        autoComplete='off'
                        name="select-publishing-vehicle"
                        multiple
                        error={addPublicationShipmentRequest?.publicationVehicles === undefined || addPublicationShipmentRequest?.publicationVehicles.length=== 0 ? true : false}
                        size="small" 
                        value={addPublicationShipmentRequest?.publicationVehicles}
                        input={<OutlinedInput />}
                        renderValue={(selected: number[]) => {
                            var newSelected =      selected.map(String)
                            let filtered = listVeiculoPublicacaoResponse?.filter(item => newSelected.includes(item.id.toString()));
                            return filtered?.map(z => z.name).join(', ');
                        }}
                    >
                        {listVeiculoPublicacaoResponse?.map((element: IPublishingVehicleResponse) => (
                       
                            <MenuItem key={element.id} value={element.id}>
                                <Checkbox name='check-vehicle-publication'
                                    value={element.id}
                                      checked={ addPublicationShipmentRequest?.publicationVehicles.some(z=>z===element.id)}
                                    onChange={handleOnChange} />
                                <ListItemText primary={element.name} />
                            </MenuItem>
                        ))}
                    </Select>


                </Grid>
                <Grid
                    item
                    lg={12}
                    sm={12}
                    xl={12}
                >
                    <InputLabel>Descrição</InputLabel>
                    <PlainTextArea
                        rows={5}
                        fullWidth
                        size="small" 
                        // defaultValue={addPublicationShipmentRequest?.description}
                        autoComplete='off'
                        onChange={handleOnChange}
                        // onBlur={handleOnChange}
                        inputProps={{ maxLength: 5000,textTransform: "uppercase" }}
                        name="input-description"
                        value={addPublicationShipmentRequest?.description}
                        error={addPublicationShipmentRequest?.description === undefined || addPublicationShipmentRequest?.description.length === 0 ? true : false}
                    />

                </Grid>
                <Grid
                    item
                    lg={12}
                    sm={12}
                    xl={12}
                >
                    <InputLabel>Observação</InputLabel>
                    <PlainTextArea
                        rows={5}
                        fullWidth
                        size="small" 
                        inputProps={{ maxLength: 5000,textTransform: "uppercase" }}
                        // defaultValue={addPublicationShipmentRequest?.observation}
                        autoComplete='off'
                        onChange={handleOnChange}
                        // onBlur={handleOnChange}
                        name="input-observation"
                        value={addPublicationShipmentRequest?.observation}
                    />

                </Grid>
                <Grid
                    item
                    lg={12}
                    sm={12}
                    xl={12}
                >
                    <DefaultUploadFiles
                        setFilesUpload={setFiles}
                        files={files}
                        extensions={["pdf","doc","docx","jpg" ,"jpeg" ,"png"]}
                        maxFileSizeMb={10}
                    />
                </Grid>
                <Grid item lg={12}
                    sm={12}
                    xl={12} sx={{
                        mt: 1,
                        display: 'flex',
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "flex-end"

                    }}>
                    <Button variant="contained" onClick={async () => {
                        await sendPublicationShipment();
                    }} endIcon={<FileUploadIcon />}>Enviar Remessa</Button>
                </Grid>
            </LocalizationProvider>
        </React.Fragment>
    )
}